import { render } from "./RegistrarReportsDialog.vue?vue&type=template&id=3592cd62"
import script from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"
export * from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__